const appEngage = /*html*/`
<div class="app-engage app-engage-hide" id="kt_app_engage">

        <!--begin::Prebuilts toggle-->
        <!--<span class="app-engage-btn hover-primary party-drawer-toggle">
            <i class="far fa-users-crown fs-2 pt-1 mb-2"></i><span class="fs-9 text-wrap w-100 text-center px-3">My party</span>
        </span>-->
        <span id="btn-global-chat" class="app-engage-btn hover-success">
            <i class="far fa-comment-alt-smile fs-2 pt-1 mb-2"></i><span class="fs-9 text-wrap w-100 text-center px-3">Global Chat</span>
        </span>
        <!--end::Prebuilts toggle-->

        <!--begin::Engage close-->
        <span id="kt_app_engage_toggle_off" class="app-engage-btn app-engage-btn-toggle-off text-hover-primary p-0">
            <i class="far fa-times fs-3"></i>
        </span>
        <!--end::Engage close-->

        <!--begin::Engage close-->
        <span id="kt_app_engage_toggle_on" class="app-engage-btn app-engage-btn-toggle-on text-hover-primary p-0" data-bs-toggle="tooltip" data-bs-placement="left" data-bs-custom-class="tooltip-inverse" data-bs-dimiss="click" aria-label="Quick Features" data-bs-original-title="Quick Features">
            <i class="fad fa-bolt fs-2 text-primary"></i>				
        </span>
        <!--end::Engage close-->
    </div>
    `;

const appGlobalChat = /*html*/`
<div id="kt_global_chat" class="bg-transparent rounded-start mt-0 mt-md-18 mt-lg-20 shadow-none d-none" data-kt-drawer-name="global" data-kt-drawer-activate="true" data-kt-drawer-overlay="true" data-kt-drawer-width="{default:'100%', 'md': '700px'}" data-kt-drawer-direction="end" data-kt-drawer-toggle="#btn-global-chat" data-kt-drawer-escape="true" data-kt-drawer-close="#global-chat-close" style="visibility: hidden;">
    <!--<div id="kt_global_chat" class="bg-transparent rounded-start mt-0 mt-md-18 mt-lg-20 shadow-none">-->
        <div class="card card-flush w-100 bg-transparent">
            <!--begin::Card header-->
            <div class="card-header border-bottom-0">
                <!--begin::Title-->
                <div class="card-title">
                   <!--<h3 class="card-title fw-bolder text-gray-700" data-i18n="globalchat.title">Global Chat</h3>-->
                </div>
                <!--end::Title-->
                <!--begin::Card toolbar-->
                <div class="card-toolbar">
                    
                    <!--begin::Close-->
                    <div class="btn btn-sm btn-icon bg-gray-100 btn-active-light-primary" id="global-chat-close">
                        <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
                        <i class="bi bi-x-lg fs-6"></i>
                        <!--end::Svg Icon-->
                    </div>
                    <!--end::Close-->
                </div>
                <!--end::Card toolbar-->
            </div>
            <!--end::Card header-->            
            <div class="card-body py-0">
                <div class="d-flex flex-column flex-lg-row">
                    <div class="flex-column flex-lg-row-auto w-100 w-md-275px mb-10 mb-lg-0">
                        <div class="card card-flush">
                            <div class="card-header bg-gray-100" id="kt_global_chat_contacts_header">
                                <div class="card-title m-0">
                                    <span class="fw-bolder text-gray-700 fs-5">Online Users</span>
                                </div>
                                <div class="card-toolbar">
                                    <span class="ms-2 badge bg-success num-online-users">0</span>
                                </div>
                            </div>

                            <div class="card-body pt-5" id="kt_global_chat_contacts_body">

                                <div class="scroll-y me-n5 pe-5 global-chat-contacts" id="global_chat_contacts_body" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_header, #kt_app_header, #kt_toolbar, #kt_app_toolbar, #kt_footer, #kt_app_footer, #kt_global_chat_contacts_header" data-kt-scroll-wrappers="#kt_content, #kt_app_content, #kt_global_chat_contacts_body" data-kt-scroll-offset="5px">
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="flex-lg-row-fluid ms-lg-7 ms-xl-10">
                        <!--begin::Messenger-->
                        <div class="card card-flush" id="kt_global_chat_messenger">
                            
                            <div class="card-header pt-7 bg-gray-100" id="kt_global_chat_messenger_header">
                                
                            </div>
                            <!--end::Card header-->

                            <!--begin::Card body-->
                            <div class="card-body bgi-size-cover bgi-position-center bgi-no-repeat" style="background-image:url('assets/media/misc/bg_chat.jpg')" id="kt_global_chat_messenger_body">
                                <!--begin::Messages-->
                                <div id="global-chat-container" class="scroll-y me-n5 pe-5" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_header, #kt_app_header, #kt_app_toolbar, #kt_toolbar, #kt_footer, #kt_app_footer, #kt_global_chat_messenger_header, #kt_global_chat_messenger_footer" data-kt-scroll-wrappers="#kt_content, #kt_app_content, #kt_global_chat_messenger_body" data-kt-scroll-offset="5px" style="">
                                </div>

                                
                                    
                            </div>
                            <!--end::Card body-->

                            <!--begin::Card footer-->
                            <div class="card-footer pt-4" id="kt_global_chat_messenger_footer">
                                <!--<div class="d-flex flex-stack">
                                    <textarea class="form-control me-4" rows="1" data-kt-element="input" placeholder="Type a message" style="width: 245px;resize:none;height: 43px;"></textarea>
                                    <button id="" class="btn btn-icon btn-light-primary btn-active-light-primary" type="button" data-kt-element="send"><i class="bi bi-send fs-4"></i></button>
                                </div>-->
                                <div class="input-group input-group-solid">
                                    <textarea id="global-chat-input" class="form-control me-4 fw-normal fs-7" rows="1" data-kt-element="input" placeholder="Type a message" style="resize:none;height: 43px;"></textarea>
                                    <button id="btn-send-global-chat" class="btn btn-icon btn-light-primary btn-active-light-primary" type="button" data-kt-element="send"><i class="bi bi-send fs-4"></i></button>
                                </div>
                            </div>
                            <!--end::Card footer-->
                        </div>
                    </div>
                        

                </div>
            </div>
            
            
            
        </div>
        
    </div>`;

const offscreen = /*html*/`
    <div id="kt_friends" class="bg-body rounded-start  mt-0 mt-md-18 mt-lg-20" data-kt-drawer="true" data-kt-drawer-name="friends" data-kt-drawer-activate="true" data-kt-drawer-overlay="false" data-kt-drawer-width="{default:'300px', 'md': '350px'}" data-kt-drawer-direction="end" data-kt-drawer-toggle="#btn-friends" data-kt-drawer-close="#friends-close" style="">
        <!--begin::Messenger-->
        <div class="card w-100 rounded-0 border-0">
            <!--begin::Card header-->
            <div class="card-header border-bottom-0 pe-5" id="kt_friends_header">
                <!--begin::Title-->
                <div class="card-title">
                    <h3 class="card-title fw-bolder text-gray-700" data-i18n="friends.myfriends">My Friends</h3>
                </div>
                <!--end::Title-->
                <!--begin::Card toolbar-->
                <div class="card-toolbar">
                    
                    <!--begin::Close-->
                    <div class="btn btn-sm btn-icon btn-active-light-primary" id="friends-close">
                        <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
                        <i class="bi bi-x-lg fs-6"></i>
                        <!--end::Svg Icon-->
                    </div>
                    <!--end::Close-->
                </div>
                <!--end::Card toolbar-->
            </div>
            <!--end::Card header-->
            <div class="border-none pt-0" id="kt_friends_find" style="padding: 2rem 2.25rem;">
                <!--begin::Description-->
                <div class="fs-8 fw-bold mb-5">
                    <span class="text-gray-600" data-i18n="friends.findsug">Find friends through suggestions from your steam account or search for a user of the platform.</span>
                </div>
                <!--end::Description-->
                <!--begin::Link-->
                <button type="button" class="btn btn-sm btn-outline btn-outline-dashed btn-outline-primary btn-active-light-primary w-100" data-bs-toggle="modal" data-bs-target="#kt_friends_search" data-i18n="friends.find">Find Friends</button>
                <!--end::Link-->                                
            </div>
            <div class="separator mx-9" id="kt_friends_separator"></div>
            <div class="separator mx-9" id="kt_friends_separator2"></div>
            <div class="separator mx-9" id="kt_friends_separator3"></div>
            
            <!--begin::Card body-->
            <div class="pt-2" id="kt_friends_pre_body" style="padding: 0rem 2.25rem;">
                
                <ul class="nav nav-pills nav-pills-custom item position-relative mb-6" id="friend-list-tab-box">
                    <!--begin::Item-->
                    <li class="nav-item col-6 mx-0 p-0">
                        <!--begin::Link-->
                        <span class="nav-link d-flex justify-content-center w-100 border-0 h-100 cursor-pointer active pb-5" data-bs-toggle="pill" href="#friend-list-box">
                            <div class="">
                                <!--begin::Subtitle-->
                                <span class="nav-text text-gray-800 fw-bolder fs-5" id="friend-list-tab" data-i18n="friends.friends">Friends</span>
                                <!--end::Subtitle-->                                    
                            </div>
                            
                            <!--begin::Bullet-->
                            <span class="bullet-custom position-absolute z-index-2 bottom-0 w-100 h-4px bg-primary rounded" id="#bullet"></span>
                            <!--end::Bullet-->
                        </span>
                        <!--end::Link-->
                    </li>
                    <!--end::Item-->
                    <!--begin::Item-->
                    <li class="nav-item col-6 mx-0 px-0">
                        <!--begin::Link-->
                        <span class="nav-link d-flex justify-content-center w-100 border-0 h-100 cursor-pointer pb-5" data-bs-toggle="pill" href="#friend-request-box">
                            <div class="">
                                <!--begin::Subtitle-->
                                <span class="nav-text text-gray-800 fw-bolder fs-5" id="friend-request-tab" data-i18n="friends.req">Requests</span>
                                <!--end::Subtitle-->
                            </div>
                            
                            <!--begin::Bullet-->
                            <span class="bullet-custom position-absolute z-index-2 bottom-0 w-100 h-4px bg-primary rounded"></span>
                            <!--end::Bullet-->
                        </span>
                        <!--end::Link-->
                    </li>
                    <!--end::Item-->
                    <!--begin::Item-->
                    
                    <!--end::Item-->
                    <!--begin::Bullet-->
                    <span class="position-absolute z-index-1 bottom-0 w-100 h-4px bg-light rounded"></span>
                    <!--end::Bullet-->
                </ul>
            </diV>
            <div class="card-body pt-0 pb-0" id="kt_friends_body">

                    <div class="tab-content hover-scroll-overlay-y" style="">
                        <div class="tab-pane fade active show" id="friend-list-box">
                            <div id="friend-list-box-header">
                                <!--begin::Form-->
                                <!--<label for="friend-list-search-input" class="form-label fs-7 fw-normal text-gray-700">Search by username</label>-->
                                <form id="friend-list-search-form" class="w-100 position-relative" autocomplete="off" onsubmit="return false;">
                                    <!--begin::Hidden input(Added to disable form autocomplete)-->
                                    <input type="hidden" />
                                    <!--end::Hidden input-->                            
                                    <!--begin::Icon-->
                                    <!--begin::Svg Icon | path: icons/duotune/general/gen021.svg-->
                                    <span class="svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 ms-5 translate-middle-y">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black" />
                                            <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black" />
                                        </svg>
                                    </span>
                                    <!--end::Svg Icon-->
                                    <!--end::Icon-->
                                    <!--begin::Input-->                            
                                    <input id="friend-list-search-input" type="text" class="form-control ps-15 text-gray-700" value="" placeholder="Search by username" data-i18n="[placeholder]friends.byuser"/>
                                    <!--end::Input-->     
                                    <span id="friend-list-search-clear" class="btn btn-flush btn-active-color-primary position-absolute top-50 end-0 translate-middle-y lh-0 me-5 d-none"><i class="bi bi-x-lg fs-6 p-0"></i></span>                      
                                </form>
                                <!--end::Form-->
                            </div>

                            <div id="friend-list-container" class="scroll-y pe-3 mt-5" data-kt-scroll="true" data-kt-scroll-activate="true" data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_friends_header,#kt_friends_find,#kt_friends_separator,#kt_friends_separator2,#kt_friends_separator3,#kt_friends_pre_body, #friend-list-search-form,#kt_friends_footer" data-kt-scroll-wrappers="#kt_friends,#kt_friends_body,#friend-list-box" data-kt-scroll-offset="0px">
                                <!--begin::Accordion-->
                                <div class="accordion accordion-icon-toggle" id="friend-online-handler">
                                    <!--begin::Item-->
                                    <div class="mb-5">
                                        <!--begin::Header-->
                                        <div class="accordion-header pt-1 d-flex" data-bs-toggle="collapse" data-bs-target="#friend-online-list">
                                            <span class="accordion-icon">
                                                <i class="bi bi-arrow-right-square"></i>
                                            </span>
                                            <div class="fs-7 mb-0 ms-2 text-gray-800"><span data-i18n="friends.online">Online</span> <span id="friend-online-num" class="d-none ms-2 badge  bg-success">0</span></div>
                                        </div>
                                        <!--end::Header-->

                                        <!--begin::Body-->
                                        <div id="friend-online-list" class="collapse show">                                           
                                        </div>
                                        <!--end::Body-->
                                    </div>
                                    <!--end::Item-->                                    


                                    <!--begin::Item-->
                                    <div class="">
                                        <!--begin::Header-->
                                        <div class="accordion-header pt-1 d-flex" data-bs-toggle="collapse" data-bs-target="#friend-offline-list">
                                            <span class="accordion-icon">
                                                <i class="bi bi-arrow-right-square"></i>
                                            </span>
                                            <div class="fs-7 mb-0 ms-2 text-gray-400"><span data-i18n="friends.offline">Offline</span> <span id="friend-offline-num" class="d-none ms-2 badge badge-sm bg-gray-300 text-white">0</span></div>
                                        </div>
                                        <!--end::Header-->

                                        <!--begin::Body-->
                                        <div id="friend-offline-list" class="fs-6 collapse show">                                   
                                        </div>
                                        <!--end::Body-->
                                    </div>
                                    <!--end::Item-->
                                </div>
                                <!--end::Accordion-->                                
                            </div>

                            <div id="friend-filter-container" class="d-none scroll-y pe-3 mt-4" data-kt-scroll="true" data-kt-scroll-activate="true" data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_friends_header,#kt_friends_find,#kt_friends_separator,#kt_friends_separator2,#kt_friends_separator3,#kt_friends_pre_body, #friend-list-search-form,#kt_friends_footer" data-kt-scroll-wrappers="#kt_friends,#kt_friends_body,#friend-list-box" data-kt-scroll-offset="0px">
                            </div>

                        </div>

                        <div class="tab-pane fade" id="friend-request-box">
                            <div id="friend-request-container" class="scroll-y" data-kt-scroll="true" data-kt-scroll-activate="true" data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_friends_header,#kt_friends_find,#kt_friends_separator,#kt_friends_separator2,#kt_friends_separator3,#kt_friends_pre_body,#kt_friends_footer" data-kt-scroll-wrappers="#kt_friends,#kt_friends_body" data-kt-scroll-offset="0px">
                            </div>
                        </div>
                    </div>
            </div>
            <!--end::Card body-->
            <!--begin::Card footer-->
            <div class="card-footer pt-4 border-top-0" id="kt_friends_footer">					
                <a href="https://discord.gg/9u4mHsf3dD" class="text-hover-success" target="_blank">
                    <div class="d-flex flex-grow-1 bgi-no-repeat bgi-size-cover bgi-position-x-center rounded h-80px w-auto px-4"
                        style="background-image:url('assets/media/misc/discord.jpeg')">
                        <div class="d-flex align-items-center flex-grow-1">
                            <!--begin::Symbol-->
                            
                            <!--end::Symbol-->
                            <!--begin::Section-->
                            <div class="me-2">
                                <div class="text-white fs-6 fw-bolder mb-2 text-hover-success">DISCORD</div>
                                <span class="text-gray-800 d-block fs-7 text-hover-white" data-i18n="friends.finddiscord">Find more friends and players from our community</span>
                            </div>
                            <!--end::Section-->
                        </div>
                        <div class="d-flex align-items-center">
                            <!--<span class="badge badge-lg badge-success align-self-center px-2">95%</span>-->
                            <i class="bi bi-chevron-right text-white fs-2 text-hover-success"></i>
                        </div>
                    </div>
                </a>
            </div>
            <!--end::Card footer-->
        </div>
        <!--end::Messenger-->
    </div>



    <div class="modal fade blur" id="kt_friends_search" tabindex="-1" aria-hidden="true">
        <!--begin::Modal dialog-->
        <div class="modal-dialog mw-400px">
            <!--begin::Modal content-->
            <div class="modal-content">
                <!--begin::Modal header-->
                <div class="modal-header border-0 px-7">
                    <!--begin::Title-->
                    <div class="modal-title">
                        <h3 class="modal-title fw-bolder text-gray-700" data-i18n="friends.find">Find Friends</h3>
                    </div>
                    <!--end::Title-->
                    <!--begin::Close-->
                    <div class="btn btn-sm btn-icon btn-active-light-primary" data-bs-dismiss="modal">
                        <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
                        <i class="bi bi-x-lg fs-6"></i>
                        <!--end::Svg Icon-->
                    </div>						
                    <!--end::Close-->
                </div>
                <!--End::Modal header-->					
                <!--begin::Modal body-->
                <div class="modal-body scroll-y pt-0 pb-15">

                    <ul class="nav nav-pills nav-pills-custom item position-relative mb-9">
                        <!--begin::Item-->
                        <li class="nav-item col-6 mx-0 p-0">
                            <!--begin::Link-->
                            <span class="nav-link d-flex justify-content-center w-100 border-0 h-100 cursor-pointer active pb-4" data-bs-toggle="pill" href="#friends-search">
                                <div class="">
                                    <!--begin::Subtitle-->
                                    <span class="nav-text text-gray-800 fw-bolder fs-5 mb-3" id="friend-search-tab" data-i18n="friends.search">Search</span>
                                    <!--end::Subtitle-->                                    
                                </div>
                               
                                <!--begin::Bullet-->
                                <span class="bullet-custom position-absolute z-index-2 bottom-0 w-100 h-4px bg-primary rounded"></span>
                                <!--end::Bullet-->
                            </span>
                            <!--end::Link-->
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="nav-item col-6 mx-0 px-0">
                            <!--begin::Link-->
                            <span class="nav-link d-flex justify-content-center w-100 border-0 h-100 cursor-pointer pb-4" data-bs-toggle="pill" href="#friends-steam">
                                <div class="">
                                    <!--begin::Subtitle-->
                                    <span class="nav-text text-gray-800 fw-bolder fs-5 mb-3" id="friend-steam-tab">Steam</span>
                                    <!--end::Subtitle-->
                                </div>
                                
                                <!--begin::Bullet-->
                                <span class="bullet-custom position-absolute z-index-2 bottom-0 w-100 h-4px bg-primary rounded"></span>
                                <!--end::Bullet-->
                            </span>
                            <!--end::Link-->
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        
                        <!--end::Item-->
                        <!--begin::Bullet-->
                        <span class="position-absolute z-index-1 bottom-0 w-100 h-4px bg-light rounded"></span>
                        <!--end::Bullet-->
                    </ul>
                
                    <div class="tab-content hover-scroll-overlay-y" style="">
                        <div class="tab-pane fade active show" id="friends-search">
                            <!--begin::Search-->
                            <div id="friend-search-handler">
                                <!--begin::Form-->
                                <label for="friend-search-input" class="form-label fs-7 fw-normal text-gray-700" data-i18n="friends.searchsug">Search users by username, SteamID or SteamID64</label>
                                <form id="friend-search-form" class="w-100 position-relative mb-5" autocomplete="off">
                                    <!--begin::Hidden input(Added to disable form autocomplete)-->
                                    <input type="hidden" />
                                    <!--end::Hidden input-->                            
                                    <!--begin::Icon-->
                                    <!--begin::Svg Icon | path: icons/duotune/general/gen021.svg-->
                                    <span class="svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 ms-5 translate-middle-y">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black" />
                                            <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black" />
                                        </svg>
                                    </span>
                                    <!--end::Svg Icon-->
                                    <!--end::Icon-->
                                    <!--begin::Input-->                            
                                    <input id="friend-search-input" type="text" class="form-control ps-15 text-gray-700" value="" placeholder=""/>
                                    <!--end::Input-->
                                    <!--begin::Spinner-->
                                    <span id="friend-search-spinner" class="position-absolute top-50 end-0 translate-middle-y lh-0 d-none me-5">
                                        <span class="spinner-border h-15px w-15px align-middle text-muted"></span>
                                    </span>
                                    <!--end::Spinner-->
                                    <!--begin::Reset-->
                                    <span id="friend-search-clear" class="btn btn-flush btn-active-color-primary position-absolute top-50 end-0 translate-middle-y lh-0 me-5 d-none">
                                        <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
                                        <!--<span class="svg-icon svg-icon-2 svg-icon-lg-1 me-0">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="black" />
                                                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="black" />
                                            </svg>
                                        </span>-->
                                        <!--end::Svg Icon-->
                                        <i class="bi bi-x-lg fs-6 p-0"></i>
                                    </span>
                                    <!--end::Reset-->
                                </form>
                                <!--end::Form-->
                                <!--begin::Wrapper-->
                                <div class="mt-16">                            
                                    <!--begin::Results(add d-none to below element to hide the users list by default)-->
                                    <div id="friends-result" class="d-none scroll-y mh-200px mh-lg-250px">
                                        
                                    </div>
                                    <!--end::Results-->
                                    <!--begin::Empty-->
                                    <div id="friends-empty" class="text-center d-none">
                                        <!--begin::Icon-->
                                            <div class="pt-0 pb-10">
                                            <!--begin::Svg Icon | path: icons/duotune/files/fil024.svg-->
                                            <span class="svg-icon svg-icon-4x opacity-50">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path opacity="0.3" d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z" fill="currentColor"></path>
                                                    <path d="M20 8L14 2V6C14 7.10457 14.8954 8 16 8H20Z" fill="currentColor"></path>
                                                    <rect x="13.6993" y="13.6656" width="4.42828" height="1.73089" rx="0.865447" transform="rotate(45 13.6993 13.6656)" fill="currentColor"></rect>
                                                    <path d="M15 12C15 14.2 13.2 16 11 16C8.8 16 7 14.2 7 12C7 9.8 8.8 8 11 8C13.2 8 15 9.8 15 12ZM11 9.6C9.68 9.6 8.6 10.68 8.6 12C8.6 13.32 9.68 14.4 11 14.4C12.32 14.4 13.4 13.32 13.4 12C13.4 10.68 12.32 9.6 11 9.6Z" fill="currentColor"></path>
                                                </svg>
                                            </span>
                                            <!--end::Svg Icon-->
                                        </div>
                                        <!--end::Icon-->
                                        <!--begin::Message-->
                                        <div class="fw-bold">
                                            <h3 class="text-gray-600 fs-5 mb-2" data-i18n="friends.nousers">No users found</h3>
                                            <div class="text-muted fs-7" data-i18n="friends.tryagain">Please try again</div>
                                        </div>
                                        <!--end::Message-->                                       
                                    </div>
                                    <!--end::Empty-->
                                </div>
                                <!--end::Wrapper-->
                            </div>
                            <!--end::Search-->
                        </div>

                        <div class="tab-pane fade" id="friends-steam">
                            <div class="tab-content hover-scroll-overlay-y" style="">                            
                                <!--<h3 class="modal-title fw-bolder text-gray-700">Steam Friends</h3>-->
                                <!--begin::Category title-->
                                <h3 class="fs-6 fw-normal text-gray-600 pb-5"><span id="friends-steam-num"></span> <span data-i18n="friends.onpdx">Steam friend(s) play on pDxPLAY</span></h3>
                                <!--end::Category title-->
                                <div class="scroll-y mh-200px mh-lg-250px suggestion-list">

                                </div>
                            </div>
                        </div>
                    
                    </div>
                    <!--end::Modal body-->
                </div>
                <!--end::Modal content-->
            </div>
        <!--end::Modal dialog-->
        </div>
    </div>






    <div id="kt_chat" class="bg-body rounded-start  mt-0 mt-md-18 mt-lg-20" data-kt-drawer="true" data-kt-drawer-name="chat" data-kt-drawer-activate="true" data-kt-drawer-overlay="false" data-kt-drawer-width="{default:'300px', 'md': '350px'}" data-kt-drawer-direction="end" data-kt-drawer-toggle="#btn-chat" data-kt-drawer-close="#chat-close" style="">
        <!--begin::Messenger-->
        <div class="card w-100 rounded-0 border-0">
            <!--begin::Card header-->
            <div class="card-header pe-5 border-bottom-0" id="kt_chat_header">
                <!--begin::Title-->
                <div class="card-title">
                    <h3 class="card-title fw-bolder text-gray-700">Chat</h3>
                </div>
                <!--end::Title-->
                <!--begin::Card toolbar-->
                <div class="card-toolbar">                    
                    <!--begin::Close-->
                    <div class="btn btn-sm btn-icon btn-active-light-primary" id="chat-close">
                        <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
                        <i class="bi bi-x-lg fs-6"></i>
                        <!--end::Svg Icon-->
                    </div>
                    <!--end::Close-->
                </div>
                <!--end::Card toolbar-->
            </div>
            <!--end::Card header-->

            <div class="d-none" id="kt_chat_pre_body" style="padding: 0rem 2.25rem;">
                
                <ul class="nav nav-pills nav-pills-custom item position-relative mb-6" id="chat-tab-box">
                    <!--begin::Item-->
                    <li class="nav-item col-6 mx-0 p-0">
                        <!--begin::Link-->
                        <span class="nav-link d-flex justify-content-center w-100 border-0 h-100 cursor-pointer active pb-5 chat-pill" data-bs-toggle="pill" href="#chat-list-box">
                            <div class="">
                                <!--begin::Subtitle-->
                                <span class="nav-text text-gray-800 fw-bolder fs-5" id="chat-list-tab">List</span>
                                <!--end::Subtitle-->                                    
                            </div>
                            
                            <!--begin::Bullet-->
                            <span class="bullet-custom position-absolute z-index-2 bottom-0 w-100 h-4px bg-primary rounded"></span>
                            <!--end::Bullet-->
                        </span>
                        <!--end::Link-->
                    </li>
                    <!--end::Item-->
                    <!--begin::Item-->
                    <li class="nav-item col-6 mx-0 px-0">
                        <!--begin::Link-->
                        <span class="nav-link d-flex justify-content-center w-100 border-0 h-100 cursor-pointer pb-5 chat-pill" data-bs-toggle="pill" href="#chat-with-box">
                            <div class="">
                                <!--begin::Subtitle-->
                                <span class="nav-text text-gray-800 fw-bolder fs-5" id="chat-with-tab">Chat</span>
                                <!--end::Subtitle-->
                            </div>
                            
                            <!--begin::Bullet-->
                            <span class="bullet-custom position-absolute z-index-2 bottom-0 w-100 h-4px bg-primary rounded"></span>
                            <!--end::Bullet-->
                        </span>
                        <!--end::Link-->
                    </li>                    
                    
                </ul>
            </div>

            <div class="card-body p-0" id="kt_chat_body">
                <div class="tab-content hover-scroll-overlay-y" style="">
                    
                    <div class="tab-pane fade active show pt-8" id="chat-list-box">
                        <div id="chat-list-box-header" class="mx-9">
                            <!--begin::Form-->                            
                            <form id="chat-list-search-form" class="w-100 position-relative" autocomplete="off" onsubmit="return false;">
                                <!--begin::Hidden input(Added to disable form autocomplete)-->
                                <input type="hidden" />
                                <!--end::Hidden input-->                            
                                <!--begin::Icon-->
                                <!--begin::Svg Icon | path: icons/duotune/general/gen021.svg-->
                                <span class="svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 ms-5 translate-middle-y">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black" />
                                        <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black" />
                                    </svg>
                                </span>
                                <!--end::Svg Icon-->
                                <!--end::Icon-->
                                <!--begin::Input-->                            
                                <input id="chat-list-search-input" type="text" class="form-control ps-15 text-gray-700" value="" placeholder=""/>
                                <!--end::Input-->     
                                <span id="chat-list-search-clear" class="btn btn-flush btn-active-color-primary position-absolute top-50 end-0 translate-middle-y lh-0 me-5 d-none"><i class="bi bi-x-lg fs-6 p-0"></i></span>                      
                            </form>
                            <!--end::Form-->
                        </div>
                        <div id="chat-list-container" class="scroll-y mt-4" data-kt-scroll="true" data-kt-scroll-activate="true" data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_chat_header,#chat-list-search-form,#kt_friends_separator3" data-kt-scroll-wrappers="#kt_chat,#kt_chat_body,#chat-list-box" data-kt-scroll-offset="0px">
                            
                        </div>
                        <div id="chat-list-empty" class="d-none text-center" data-kt-scroll="true" data-kt-scroll-activate="true" data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_chat_header,#chat-list-search-form,#kt_friends_separator3" data-kt-scroll-wrappers="#kt_chat,#kt_chat_body,#chat-list-box" data-kt-scroll-offset="0px">
                            <!--begin::Icon-->
                                <div class="pt-15 pb-6">
                                <!--begin::Svg Icon | path: icons/duotune/files/fil024.svg-->
                                <span class="svg-icon svg-icon-primary svg-icon-4x opacity-50">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path opacity="0.3" d="M20 3H4C2.89543 3 2 3.89543 2 5V16C2 17.1046 2.89543 18 4 18H4.5C5.05228 18 5.5 18.4477 5.5 19V21.5052C5.5 22.1441 6.21212 22.5253 6.74376 22.1708L11.4885 19.0077C12.4741 18.3506 13.6321 18 14.8167 18H20C21.1046 18 22 17.1046 22 16V5C22 3.89543 21.1046 3 20 3Z" fill="currentColor"/>
                                    <rect x="6" y="12" width="7" height="2" rx="1" fill="currentColor"/>
                                    <rect x="6" y="7" width="12" height="2" rx="1" fill="currentColor"/>
                                    </svg>
                                </span>
                                <!--end::Svg Icon-->
                            </div>
                            <!--end::Icon-->
                            <!--begin::Message-->
                            <div class="fw-bold">
                                <h3 class="text-gray-600 fs-5 mb-2">No chats found</h3>
                                <div class="text-muted fs-7">Try sending a message to a friend</div>
                            </div>
                            <!--end::Message-->                                       
                        </div>
                    </div>

                    <div class="tab-pane fade" id="chat-with-box">
                        <div class="card w-100 rounded-0 border-0" id="chat-with-card">
                            <div class="card-header pe-5" id="chat-with-header">
                                <!--begin::Title-->
                                
                                <!--end::Title-->
                                <!--begin::Card toolbar-->
                                
                                <div class="card-title">
                                    <div class="btn btn-sm btn-icon btn-outline-primary btn-active-light-primary chat-back">
                                        <i class="bi bi-arrow-left fs-2 fw-bolder"></i>
                                    </div><!--begin::User-->
                                    <div class="ms-5 symbol symbol-45px">
                                        <img class="chat-with-avatar" alt="Pic" src="assets/media/avatars/300-1.jpg">
                                        
                                    </div><div class="d-flex justify-content-center flex-column ms-5">
                                        <a href="#" class="fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-2 lh-1 chat-with-profile-url text-nowrap text-truncate" data-navigo style="max-width:120px;"><span class="chat-with-nickname"></span></a>
                                        <!--begin::Info-->
                                        <div id="chat-active-indicator" class="mb-0 lh-1">
                                            
                                        </div>
                                        <!--end::Info-->
                                    </div>
                                    <!--end::User-->
                                </div>
                                <div class="card-toolbar">
                                    
                                    
                                    
                                </div><!--end::Card toolbar-->
                            </div>

                            <div class="card-body" id="chat-with-body">
                                <!--begin::Messages-->
                                <div id="chat-with-container" class="scroll-y me-n5 pe-5" data-kt-scroll="true" data-kt-scroll-activate="true" data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_chat_header,#chat-with-header,#chat-with-footer" data-kt-scroll-wrappers="#kt_chat,#kt_chat_body,#chat-with-box,#chat-with-card,#chat-with-body" data-kt-scroll-offset="0px">
                                </div>
                                <!--end::Messages-->                                
                            </div>

                            <div class="card-footer py-4" id="chat-with-footer">
                                <!--begin::Input-->                                
                                <!--begin:Toolbar-->
                                <div class="d-flex flex-stack">                                                                        
                                    <textarea class="form-control me-4 chat-with-text" rows="1" data-kt-element="input" placeholder="Type a message" style="width: 245px;resize:none;height: 43px;"></textarea><!--end::Send-->
                                    <button id="chat-with-send" class="btn btn-icon btn-light-primary btn-active-light-primary" type="button" data-kt-element="send"><i class="bi bi-send fs-4"></i></button>
                                </div>
                                <!--end::Toolbar-->
                                <!--end::Input-->
                            </div>

                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>


    <div class="modal fade" tabindex="-1" id="kt_modal_error">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header py-4">
                    <h3 id="merror-title" class="modal-title fw-bolder text-gray-700"></h3>

                    <!--begin::Close-->
                    <div class="btn btn-sm btn-icon btn-light-primary" data-bs-dismiss="modal">
                        <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
                        <i class="bi bi-x-lg fs-6"></i>
                        <!--end::Svg Icon-->
                    </div>
                    <!--end::Close-->
                </div>

                <div class="modal-body py-6">
                    <p id="merror-content" class="mb-0"></p>
                </div>

                <div class="modal-footer border-0 py-4">                    
                    <button type="button" class="btn btn-sm btn-primary text-black fw-bolder" data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    
    
    <style>
        .akros-app {
            position: fixed;
            left: 100px;
            bottom: 80px;            
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            z-index: 5;            
        }
        
    </style>

    <div class="akros-app">
        <div class="d-flex flex-column flex-root btn-akros">
        </div>
    </div>

    <div id="akros-modal-processing" class="modal fade" tabindex="-1" data-bs-keyboard="false" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header border-0">
                    <h2 class="modal-title" data-i18n="akros.ac">Akros Anticheat</h2>
                    <button disabled class="btn btn-icon btn-active-color-primary " data-bs-dismiss="modal"><span class="svg-icon svg-icon-gray-600 svg-icon-2qx m-0"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor"/><rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"/><rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"/></svg></span></button>
                    
                </div>
                <div class="modal-body modal-body fs-5 fw-semibold text-gray-700 akros-modal-body text-center">
                    <div class="d-flex justify-content-center pb-10">
                        <div class="spinner-border text-primary text-center" role="status" style="width: 3rem; height: 3rem;animation: 1.2s linear infinite spinner-border;">
                        </div>                                                       
                    </div>
                    <div class="pb-10 fw-semibold">
                        <h3 class="text-gray-600 fs-5 mb-2" data-i18n="akros.looking">Looking for Akros...</h3>
                    </div>
                </div>                
            </div>
        </div>
    </div>

    <div id="akros-modal" class="modal fade" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header border-0">
                    <h2 class="modal-title" data-i18n="akros.ac">Akros Anticheat</h2>
                    <button class="btn btn-icon btn-active-color-primary " data-bs-dismiss="modal"><span class="svg-icon svg-icon-gray-600 svg-icon-2qx m-0"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor"/><rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"/><rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"/></svg></span></button>
                    
                </div>
                <div class="modal-body modal-body fs-5 fw-semibold text-gray-700 akros-modal-body" data-i18n="akros.modal_body">
                    You might be required to install Akros Anti-cheat to play ranked matches. If you have it installed, press launch, otherwise download it below.
                </div>
                <div class="modal-footer border-0 akros-modal-footer">                        
                    <a data-bs-dismiss="modal" href="akros://init/" class="btn btn-sm btn-primary btn-color-gray-200 external-handler btn-akros-launch" data-i18n="akros.launch">Launch</a>
                    <a data-bs-dismiss="modal" href="services/anticheat" data-navigo class="btn btn-sm btn-light" data-i18n="example.download">Download</a>
                </div>
            </div>
        </div>
    </div>



    


    <span class="d-flex app-global-chat px-3 btn btn-active-success btn-active-color-gray-200 btn-icon-gray-700 gap-4 shadow-none">
        <div class="d-flex flew-nowrap fs-7 app-global-chat-new-incoming-msg d-none"></div>
        <div class="d-flex flew-nowrap align-items-center"><i class="far fa-comments-alt fs-2 mt-1 me-1"></i><span class="fs-8 text-wrap w-100 text-center">Global Chat</span></div>
        <div class="d-flex flew-nowrap align-items-center"><i class="far fa-user fs-4 me-0"></i><span class="fs-7 text-wrap w-100 text-center app-global-chat-online-users">0</span></div>
    </span>

    <div id="global-chat" class="window card card-flush bg-transparent p-0 m-0 d-none app-global-chat-window" style="z-index: 150">        
        <div class="p-2 h-100">
            <div class="card card-flush h-100" id="kt_global_chat_messenger">
                                
                <div class="card-header min-h-50px bg-gray-100 custom-window-header px-6" id="kt_global_chat_messenger_header" style="cursor: all-scroll;">
                    <div class="card-title m-0">
                        <span class="fw-bolder text-gray-700 fs-5">Global Chat</span>
                    </div>
                    
                    <div class="card-toolbar">                        
                        <div class="btn btn-sm btn-icon w-25px h-25px bg-gray-200 btn-active-light-primary app-global-chat-hide" id="global-chat-close">                            
                            <i class="bi bi-x-lg fs-7"></i>
                        </div>                        
                    </div>                    
                </div>
                
                <div id="global-chat-container" class="card-body bgi-position-center bgi-repeat bg-opacity-25 ps-6 me-n1 pe-4 pb-1" style="/*background-image:url('assets/media/misc/bg_chat.jpg');background-size:300px 600px;*/overflow-y: auto;">                            
                    
                </div>
                                
                <div class="card-footer p-4" id="kt_global_chat_messenger_footer">                            
                    <div class="input-group input-group-solid">
                        <textarea id="global-chat-input" class="form-control me-4 fw-normal fs-7" rows="1" data-kt-element="input" placeholder="Type a message" style="resize:none;height: 43px;"></textarea>
                        <button id="btn-emojis-global-chat" class="btn btn-icon btn-active-color-zyellow" type="button" data-kt-element="send"><i class="far fa-smile-beam fs-3"></i></button>
                        <button id="btn-send-global-chat" class="btn btn-icon btn-active-color-info" type="button" data-kt-element="send"><i class="fad fa-paper-plane fs-4"></i></button>
                    </div>
                </div>
                
            </div>
        </div>
        
        
        
    </div>

    
    `;



export default offscreen;
